require('../../modules/es6.string.starts-with');
module.exports = require('../../modules/_core').String.startsWith;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/string/starts-with.js
// module id = 413
// module chunks = 10